export const OptionBimestre = [{
    id: 1,
    name: "1er Bimestre",
}, {
    id: 2,
    name: "2do Bimestre",
}, {
    id: 3,
    name: "3er Bimestre",
}, {
    id: 4,
    name: "4to Bimestre",
}]